import React, { useState } from "react";
import {
  Modal,
  Button,
  Input,
  Typography,
  Row,
  Col,
  Divider,
  Space,
  Flex,
  notification,
  Spin,
} from "antd";
import talentPoolsIcon from "../../images/talentpools.svg";
import websiteLogo from "../../images/logo.png";
import playButtonIcon from "../../images/playButton.svg";
import {
  CloseOutlined,
  PlayCircleOutlined,
  SendOutlined,
  ShareAltOutlined,
  UsergroupAddOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { SvgIcons } from "Icon/SvgIcons";
import { referFriend } from "api/candidate.api";

const { Title, Text } = Typography;

interface AffiliateProgramProps {
  isVisible: boolean;
  onClose: () => void;
}

const AffiliateProgram: React.FC<AffiliateProgramProps> = ({ isVisible, onClose }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState<{ name?: string; email?: string }>({});
  const [loading, setLoading] = useState(false);

  // Email validation regex
  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);

    if (!value) {
      setError((prev) => ({ ...prev, email: "Email is required" }));
    } else if (!validateEmail(value)) {
      setError((prev) => ({ ...prev, email: "Invalid email format" }));
    } else {
      setError((prev) => ({ ...prev, email: "" }));
    }
  };

  const handleNameChange = (e: any) => {
    const value = e.target.value;
    setName(value);

    if (!value) {
      setError((prev) => ({ ...prev, name: "Name is required" }));
    } else {
      setError((prev) => ({ ...prev, name: "" }));
    }
  };

  const handleSendInvitation = async () => {
    let hasError = false;

    if (!name) {
      setError((prev) => ({ ...prev, name: "Name is required" }));
      hasError = true;
    }
    if (!email) {
      setError((prev) => ({ ...prev, email: "Email is required" }));
      hasError = true;
    } else if (!validateEmail(email)) {
      setError((prev) => ({ ...prev, email: "Invalid email format" }));
      hasError = true;
    } else {
      setError((prev) => ({ ...prev, email: "" }));
    }
    if (hasError) return;

    // if (!validateEmail(email)) {
    //     notification.error({
    //         message: "Invalid Email",
    //         description: "Please enter a valid email address before sending the invitation."
    //     });
    //     return;
    // }

    setLoading(true);
    try {
      const data = {
        referred_name: name,
        referred_email: email,
      };

      const res = await referFriend(data);
      if (res) {
        notification.success({
          message: "Submission Successful",
          description: "Referral submitted successfully!",
        });
        setEmail("");
        setName("");
      } else {
        notification.error({
          message: "Submission Failed",
          description: "Something went wrong, please try again.",
        });
      }
    } catch (error: any) {
      notification.error({
        message: "Submission Failed",
        description: error.message ? error.message : "Failed to submit referral.",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal
      open={isVisible}
      onCancel={onClose}
      footer={null}
      width={800}
      bodyStyle={{ padding: 0 }} // Remove default padding for modal body
      closeIcon={<CloseOutlined style={{ color: "#9098a0" }} />}
    >
      {/* Header Section */}
      <div
        style={{
          backgroundColor: "#F9F5FF", // Light gray background
          padding: "16px 24px", // Add padding inside the header
          borderRadius: "8px 8px 0 0", // Rounded corners for the top
          margin: "-24px",
        }}
      >
        <Row justify="space-between" align="middle">
          <div className="flex items-center justify-center logo-wrapper">
            <img
              src={websiteLogo}
              alt="LOGO"
              className="main-logo max-w-36 max-h-16 w-auto h-auto block"
            />
          </div>
          {/* Left Side: Title and Subtitle */}
          {/* <Col>
                        <Row align="middle" gutter={8}>
                            <Col>
                                <img
                                    src={websiteLogo} // Replace with your actual image path
                                    alt="Affiliate Program Icon"
                                    style={{
                                        width: 35,
                                        height: 35,
                                        backgroundColor: "#F4EBFF",
                                        padding: "2px",
                                        borderRadius: "3px", // Rounded corners
                                        border: "1px solid #E4E7EC", // Light gray border
                                    }}
                                />
                            </Col>
                            <Col>
                                <Text
                                    style={{
                                        fontSize: "14px",
                                        // color: "#9098a0",
                                        fontWeight: 500,
                                        lineHeight: "1.2", // Adjust line height for proper spacing
                                    }}
                                >
                                    Start Your Affiliate Program
                                </Text>
                                <Text
                                    style={{
                                        fontSize: "12px",
                                        color: "#b0b8c1",
                                        display: "block",
                                        marginTop: 2, // Small spacing between lines
                                    }}
                                >
                                    Simple and flexible per-user pricing.
                                </Text>
                            </Col>
                        </Row>
                    </Col> */}
          {/* Right Side: Video Tutorial Button */}
          {/* <Col>
                        <Button
                            type="link"
                            icon={<PlayCircleOutlined />}
                            style={{
                                color: "#916ce8",
                                fontSize: "14px",
                                fontWeight: 500,
                            }}
                        >
                            Video tutorial
                        </Button>
                    </Col> */}
        </Row>
      </div>
      <Divider />
      <Row justify="space-between" align="middle">
        <Title level={2} style={{ color: "#475467", fontWeight: "800", fontFamily: "Inter" }}>
          Refer a Friend
        </Title>
        {/* <Flex wrap gap="small" className="site-button-ghost-wrapper">
                    <Button
                        icon={<PlayCircleOutlined />}
                        // icon={<img src={playButtonIcon} alt="" />}
                        style={{
                            color: "#916ce8",
                            fontSize: "14px",
                            fontWeight: 500,
                        }}
                    >
                        Video tutorial
                    </Button>
                </Flex> */}
      </Row>
      {/* <Divider /> */}
      {/* <div>
                <Row gutter={[16, 16]} justify="center">
                    <Col span={8}>
                        <Button
                            type="default"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                width: "100%",
                                padding: "16px",
                                borderRadius: "8px",
                                border: "1px solid #e6e8ec",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                                height: "70px"
                            }}
                        >
                            <div
                                style={{
                                    width: 50,
                                    height: 40,
                                    backgroundColor: "#f9faff",
                                    borderRadius: "8px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "1px solid #e6e8ec", // Add border to the icon container
                                }}
                            >
                                <UserOutlined style={{ fontSize: "24px", color: "#6c757d" }} />
                            </div>
                            <div>
                                <Text strong style={{ fontSize: "16px", color: "#2c3e50" }}>
                                    Earn More Credits
                                </Text>
                                <Text
                                    type="secondary"
                                    style={{
                                        fontSize: "11px",
                                        display: "block",
                                        marginTop: "4px",
                                    }}
                                >
                                    Add yourself or import from CSV
                                </Text>
                            </div>
                        </Button>
                    </Col>
                    <Col span={8}>
                        <Button
                            type="default"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                width: "100%",
                                padding: "16px",
                                borderRadius: "8px",
                                border: "1px solid #e6e8ec",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                                height: "70px"
                            }}
                        >
                            <div
                                style={{
                                    width: 50,
                                    height: 40,
                                    backgroundColor: "#f9faff",
                                    borderRadius: "8px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "1px solid #e6e8ec", // Add border to the icon container
                                }}
                            >
                                <ShareAltOutlined style={{ fontSize: "24px", color: "#6c757d" }} />
                            </div>
                            <div>
                                <Text strong style={{ fontSize: "16px", color: "#2c3e50" }}>
                                    Earn More Credits
                                </Text>
                                <Text
                                    type="secondary"
                                    style={{
                                        fontSize: "11px",
                                        display: "block",
                                        marginTop: "4px",
                                    }}
                                >
                                    Add yourself or import from CSV
                                </Text>
                            </div>
                        </Button>
                    </Col>
                    <Col span={8}>
                        <Button
                            type="default"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                width: "100%",
                                padding: "16px",
                                borderRadius: "8px",
                                border: "1px solid #e6e8ec",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                                height: "70px"
                            }}
                        >
                            <div
                                style={{
                                    width: 50,
                                    height: 40,
                                    backgroundColor: "#f9faff",
                                    borderRadius: "8px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "1px solid #e6e8ec", // Add border to the icon container
                                }}
                            >
                                <UsergroupAddOutlined style={{ fontSize: "24px", color: "#6c757d" }} />
                            </div>
                            <div>
                                <Text strong style={{ fontSize: "16px", color: "#2c3e50" }}>
                                    Earn More Credits
                                </Text>
                                <Text
                                    type="secondary"
                                    style={{
                                        fontSize: "11px",
                                        display: "block",
                                        marginTop: "4px",
                                    }}
                                >
                                    Add yourself or import from CSV
                                </Text>
                            </div>
                        </Button>
                    </Col>
                </Row>
            </div> */}

      <Divider />

      <Row gutter={[16, 16]}>
        <Col span={24}>
          {/* Title Section */}
          <Title
            level={4}
            style={{
              color: "#673ab7", // Purple color for title
              fontWeight: 700,
            }}
          >
            <Text style={{ color: "#673ab7", fontWeight: 700, fontSize: "xx-large" }}>1.</Text>{" "}
            Refer a friend for <Text style={{ color: "#4caf50" }}>100 free credits</Text>
          </Title>
          {/* Description */}
          <Text style={{ color: "#616161", fontSize: "14px" }}>
            Looking for additional credits at no cost to you? Utilize our referral option to send
            credits to friends, in return we will gift you 100 credits for every accepted referral!
          </Text>

          {/* Input and Button Row */}
          <Row style={{ marginTop: "16px" }} gutter={16}>
            <Col span={12}>
              <div style={{ marginBottom: "8px" }}>
                <label style={{ fontSize: "14px", fontWeight: "bold", color: "#616161" }}>
                  Friend&apos;s name
                </label>
              </div>
              <Input
                value={name}
                placeholder="Enter Friend's Name"
                onChange={handleNameChange}
                style={{
                  height: "42px",
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0",
                  padding: "10px 12px",
                  backgroundColor: "#f9f9f9",
                  fontSize: "14px",
                  width: "100%", // Ensures the input takes up full space in the column
                }}
              />
              {error.name && <span style={{ color: "red", fontSize: "12px" }}>{error.name}</span>}
            </Col>

            <Col span={12}>
              <div style={{ marginBottom: "8px" }}>
                <label style={{ fontSize: "14px", fontWeight: "bold", color: "#616161" }}>
                  Friend&apos;s e-mail address
                </label>
              </div>
              <Input
                value={email}
                placeholder="Enter Friend's e-mail"
                onChange={handleEmailChange}
                style={{
                  height: "42px",
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0",
                  padding: "10px 12px",
                  backgroundColor: "#f9f9f9",
                  fontSize: "14px",
                  width: "100%", // Ensures the input takes up full space in the column
                }}
              />
              {error.email && <span style={{ color: "red", fontSize: "12px" }}>{error.email}</span>}
            </Col>
          </Row>

          <Row
            style={{
              marginTop: "16px", // Spacing from the description
              alignItems: "center",
            }}
            gutter={16}
          >
            {/* <Col>
                            <Text strong style={{ color: "#673ab7", fontSize: "larger" }}>
                                Invite Individual
                            </Text>
                        </Col>
                        <Col flex="auto">
                            <Input
                                value={email}
                                placeholder="Enter E-mail(s) here"
                                onChange={handleEmailChange}
                                style={{
                                    height: "42px", // Match height with the button
                                    borderRadius: "8px", // Rounded corners
                                    border: "1px solid #e0e0e0", // Light border
                                    padding: "10px 12px", // Inner padding for proper alignment
                                    backgroundColor: "#f9f9f9", // Light gray background
                                    fontSize: "14px", // Font size for input text
                                }}
                            />
                            {error && <span style={{ color: "red", fontSize: "12px" }}>{error}</span>}
                        </Col> */}
            <Col>
              <Button
                type="primary"
                onClick={() => handleSendInvitation()}
                style={{
                  height: "42px", // Match height with input
                  // borderRadius: "8px", // Rounded corners
                  // backgroundColor: "#673ab7", // Purple button
                  // border: "none",
                  // padding: "0 16px", // Horizontal padding
                  // display: "flex",
                  // alignItems: "center", // Center content vertically
                }}
                icon={
                  loading ? (
                    <Spin spinning={loading} size="small" className="custom-spin" />
                  ) : (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.74928 11.2501L17.4993 2.50014M8.85559 11.5235L11.0457 17.1552C11.2386 17.6513 11.3351 17.8994 11.4741 17.9718C11.5946 18.0346 11.7381 18.0347 11.8587 17.972C11.9978 17.8998 12.0946 17.6518 12.2881 17.1559L17.78 3.08281C17.9547 2.63516 18.0421 2.41133 17.9943 2.26831C17.9528 2.1441 17.8553 2.04663 17.7311 2.00514C17.5881 1.95736 17.3643 2.0447 16.9166 2.21939L2.84349 7.71134C2.34759 7.90486 2.09965 8.00163 2.02739 8.14071C1.96475 8.26129 1.96483 8.40483 2.02761 8.52533C2.10004 8.66433 2.3481 8.7608 2.84422 8.95373L8.47589 11.1438C8.5766 11.183 8.62695 11.2026 8.66935 11.2328C8.70693 11.2596 8.7398 11.2925 8.7666 11.3301C8.79685 11.3725 8.81643 11.4228 8.85559 11.5235Z"
                        stroke="white"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )
                }
              >
                {/* <SendOutlined style={{ marginRight: "8px" }} /> */}
                Send Invitation
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <Divider />

      {/* <Row gutter={[16, 16]}>
                <Col span={24}>
                    <Title level={5}>
                        2. Share affiliate link <Text type="success">+150 credits</Text>
                    </Title>
                    <Text>
                        Lorem ipsum dolor sit amet consectetur. Netus aliquet mauris eu sed
                        aliquet. Donec ut amet diam massa massa quam aliquam proin
                        adipiscing.
                    </Text>
                    <Row style={{ marginTop: 16 }} gutter={16}>
                        <Col span={16}>
                            <Input
                                value="https://www.sinecure.ai/affiliate+150credits"
                                readOnly
                            />
                        </Col>
                        <Col span={8}>
                            <Button type="primary" block>
                                Copy Link
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row> */}
    </Modal>
  );
};

export default AffiliateProgram;
